import React, { ReactNode } from 'react';

import styles from './row.scss';

interface Props {
  children?: ReactNode | ReactNode[];
  className?: string;
}

const Row: React.FC<Props> = ({ children, className }) => {
  return <div className={`${styles.row} ${className || ''}`}>{children}</div>;
};

export default Row;
